<i18n>
{
  "fr": {
    "tool-title": "Mesures disponibles",
    "measured-parameter": "Paramètre mesuré",
    "data-since": "Première donnée",
    "goto-data": "Voir les chroniques",
    "last-value": "Dernières valeurs",
    "last-update": "Dernière mise à jour le "
  },
  "de": {

  }
}
</i18n>

<template>
  <div id="vector-info" class="tool" v-if="show">
    <h3>{{$t('tool-title')}}</h3>
    <md-content class="md-scrollbar main-container">
      <div>
        <span>{{ getMaxDate() | formatDatetime}}</span>
        <md-table>
          <md-table-row
            v-for="paramterType in availableParameterTypes"
            :key="paramterType.id"
          >
            <md-table-cell>{{ paramterType.name[$i18n.locale] }} [{{ paramterType.unit.symbol[$i18n.locale] }}]</md-table-cell>
            <md-table-cell>{{ getLastValue(paramterType.id) }}</md-table-cell>
          </md-table-row>
        </md-table>

        <md-button class="show-timeseries md-raised" @click="gotoTimeseries()">{{ $t('goto-data') }}</md-button>
      </div>

    </md-content>
  </div>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

import MapStoreMixin from '@/mixins/store/map'
import LayerStoreMixin from '@/mixins/store/layer'

export default {
  name: 'DatasourcesDescription',
  mixins: [
    MapStoreMixin,
    LayerStoreMixin
  ],
  props: {
    params: {
      type: Object,
      default: () => { return {} }
    }
  },
  filters: {
    formatDatetime (momentDate) {
      return momentDate.format('DD.MM.YYYY HH:mm')
    }
  },
  computed: {
    show () {
      return !_.isEmpty(this.currentObject)
    },
    availableParameterTypes () {
      let toReturn = new Map()
      this.datasources.forEach((datasource) => { toReturn.set(datasource.parameterType.id, datasource.parameterType) })
      return Array.from(toReturn, ([key, value]) => value) // eslint-disable-line no-unused-vars
    },
    datasources () {
      if (_.isEmpty(this.currentObject)) return []
      return this.currentObject.datasources.filter((datasource) => this.params.parameterTypeCodes.includes(datasource.parameterType.code))
    }
  },
  methods: {
    getMaxDate () {
      let toReturn = moment.utc(this.datasources[0].stats.maxDate).utcOffset(60)
      this.datasources.forEach((datasource) => {
        if (toReturn.isBefore(datasource.stats.maxDate)) toReturn = moment.utc(datasource.stats.maxDate)
      })
      return toReturn
    },
    getLastValue (paramterTypeId) {
      let toReturn = '-'
      let datasources = this.datasources.filter((datasource) => {
        return datasource.parameterType.id === paramterTypeId
      })

      if (_.isEmpty(datasources)) return toReturn

      // On détermine quel datasource dispose de la dernière valeur
      let maxDate = moment.utc(datasources[0].stats.maxDate)
      let lastUpdatedDatasource = datasources[0]
      datasources.forEach((datasource) => {
        if (maxDate.isBefore(datasource.stats.maxDate)) {
          maxDate = moment.utc(datasource.stats.maxDate)
          lastUpdatedDatasource = datasource
        }
      })

      return lastUpdatedDatasource.stats.lastValue
    },
    gotoTimeseries () {
      let routeData = this.$router.resolve({name: 'observation-point-data', params: { id: this.currentObject.id }});
      window.open(routeData.href, '_blank');
    },
    handleError (e) {
      console.log(e)
    }
  }
}
</script>

<style lang="scss">
  #vector-info {
    width: 100%;

    .close-button {
      display: block;
      margin-left: auto;
      margin-right: 15px;
      margin-bottom: -30px;
      margin-top: 5px;
    }

    .md-content.main-container {
      overflow-y: auto;
      overflow-x: hidden;
      background: none;

      @media (max-height: 500px) {
        max-height: 100vh;
      }
    }

    .layer-name {
      font-size: 14px;
    }

    .container {
      margin-left: -10px;
      margin-right: -10px;
      background-color: white;

      h2 {
        margin-top: 5px;
      }
    }

    .plotly {
      width: 100%;
      height: 250px;
    }

    .empty-data {
      margin-top: 15px;
      margin-bottom: 15px;

      .md-icon {
        width: 80px;
        min-width: 80px;
        font-size: 80px !important;
      }
      .md-empty-state-label {
        font-size: 18px;
        line-height: 18px;
      }

      &.md-empty-state-leave-active {
        display: none !important;
      }
    }

    .show-timeseries {
      margin-left: auto;
      margin-right: auto;
    }

    .data-table {
      .md-table-row {
        .md-table-cell:first-child {
          max-width: 190px;
          word-wrap: break-word;
        }
      }
    }
  }
</style>
